import React, { useEffect } from "react";
import AOS from "aos";
import { motion } from "framer-motion";
import Hero from "../components/Hero";

const videos = [
    "https://www.youtube.com/embed/ktD88NknV_M",
    "https://www.youtube.com/embed/JP45EcvMM5I",
    "https://www.youtube.com/embed/9f_PUbDmKiY",
    "https://www.youtube.com/embed/n_7Zgs9deXA",
    "https://www.youtube.com/embed/XzWrzruDDQE",
    "https://www.youtube.com/embed/thBwaacrWUM",
    "https://www.youtube.com/embed/T3KjmX71L6U",
    "https://www.youtube.com/embed/FHaNtB2VWA0",
    "https://www.youtube.com/embed/SkNSUAM6PmQ",
    "https://www.youtube.com/embed/U0m9xD9DG44",
    "https://www.youtube.com/embed/WZbhMTxGgtE",
    "https://www.youtube.com/embed/E500dYzCFJA",
    "https://www.youtube.com/embed/6_BBRApvWp8",
    "https://www.youtube.com/embed/1lSS6aBfl4Y",
];

const VideosAndReferences = () => {
    useEffect(() => {
        AOS.init({ duration: 800, once: true });
    }, []);

    // Ensure the page scrolls to top whenever this page is navigated to or the id changes
    useEffect(() => {
        try {
            if (typeof window !== 'undefined' && window?.scrollTo) {
                // instant jump to top to avoid flashing at previous scroll position
                window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
            }
        } catch (e) {
            // fallback: simple assignment
            try {
                window.scrollTo(0, 0);
            } catch (err) {
                // ignore in environments without window
            }
        }
    }, []);

    const heroSlides = [
        {
            id: 1,
            image: "/assets/img/prog-1.jpg",
            title: "Videos and References",
            subtitle:
                "Explore helpful videos and resources that deepen your understanding.",
            buttonText: "Explore Now",
            buttonLink: "#videos-section",
        },
    ];

    return (
        <section className="bg-gray-50 min-h-screen pt-1">

            <div
                className="container my-16 mx-auto px-6 py-16 text-center"
                id="videos-section"
            >
                <h2 className="text-3xl font-bold mb-10 text-gray-800">
                    Featured Videos
                </h2>

                <motion.div
                    className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8"
                    initial={{ opacity: 0, y: 12 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    {videos.map((url, i) => (
                        <motion.div
                            key={i}
                            className="bg-white rounded-xl overflow-hidden shadow hover:shadow-lg transition-transform transform hover:-translate-y-1"
                            data-aos="fade-up"
                            data-aos-delay={i * 50}
                        >
                            <div className="aspect-w-16 aspect-h-9">
                                <iframe
                                    src={url}
                                    title={`Video ${i + 1}`}
                                    allowFullScreen
                                    frameBorder="0"
                                    className="w-full h-64 sm:h-60"
                                ></iframe>
                            </div>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
};

export default VideosAndReferences;
